export enum Companies {
  GREENERY_BELGRADE = 'GREENERY_BELGRADE',
  SREMCICA = 'SREMCICA',
}
